import React from 'react';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
  const services = [
    {
      id: 1,
      title: "VİOP İŞLEMLERİ",
      url: "/hizmetler/viop-islemleri",
      image: "https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/qih3ju09_viop.png",
      color: "from-pink-400 to-pink-500"
    },
    {
      id: 2,
      title: "PAY ALIM-SATIM",
      url: "/hizmetler/pay-alim-satim",
      image: "https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/941o2s4c_payalim.png",
      color: "from-yellow-400 to-yellow-500"
    },
    {
      id: 3,
      title: "YATIRIM DANIŞMANLIĞI",
      url: "/hizmetler/yatirim-danismanligi",
      image: "https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/gokfabac_ytd.png",
      color: "from-purple-400 to-purple-500"
    },
    {
      id: 4,
      title: "YATIRIM FONLARI",
      url: "/hizmetler/yatirim-fonlari",
      image: "https://customer-assets.emergentagent.com/job_colendi-replica/artifacts/f4p0nkgh_ytf.png",
      color: "from-cyan-400 to-cyan-500"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Hero Section */}
      <section className="bg-white py-12">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4 text-gray-900" style={{ fontFamily: 'Arial, sans-serif', fontStretch: 'condensed' }}>
            Hizmetlerimiz
          </h1>
          <p className="text-gray-600 text-lg">Profesyonel yatırım hizmetleri ile yanınızdayız</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-12 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((service) => (
              <Link
                key={service.id}
                to={service.url}
                className="group bg-white rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className={`h-1 bg-gradient-to-r ${service.color}`}></div>
                <div className="p-8 text-center">
                  <div className="flex justify-center mb-6">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-24 h-24 object-contain"
                    />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-8 uppercase tracking-tight">
                    {service.title}
                  </h3>
                  <div className="pt-4 border-t border-gray-200">
                    <span className="text-sm font-medium text-gray-900">Hemen İncele</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
